import { mdiAccountTieOutline, mdiBellOutline, mdiClipboardPulseOutline, mdiDomain, mdiPulse, mdiCodeBraces, mdiViewDashboardOutline } from "@mdi/js";

export const screens = [
	{
		menu: null,
		name: "Dashboard",
		description: "",
		icon: mdiViewDashboardOutline,
		route: "/dashboard",
		showSidebar: true,
		showDashboard: false,
	},
	{
		menu: null,
		name: "Monitores",
		description: "Lista de monitores",
		icon: mdiPulse,
		route: "/monitores",
		showSidebar: true,
		showDashboard: true,
	},
	{
		menu: null,
		name: "Grupos",
		description: "Lista de grupos",
		icon: mdiClipboardPulseOutline,
		route: "/grupos",
		showSidebar: true,
		showDashboard: true,
	},
	{
		menu: null,
		name: "Alertas",
		description: "Lista de alertas",
		icon: mdiBellOutline,
		route: "/alertas",
		showSidebar: true,
		showDashboard: true,
	},
	{
		menu: null,
		name: "Variaveis",
		description: "Lista de variáveis",
		icon: mdiCodeBraces,
		route: "/variaveis",
		showSidebar: true,
		showDashboard: true,
	},
	{
		menu: null,
		name: "Empresas",
		description: "Lista de empresas",
		icon: mdiDomain,
		route: "/empresas",
		showSidebar: true,
		showDashboard: true,
		superUser: true,
	},
	{
		menu: null,
		name: "Usuários",
		description: "Lista de usuários",
		icon: mdiAccountTieOutline,
		route: "/usuarios",
		showSidebar: true,
		showDashboard: true,
	},
];
